import { useEffect } from 'react'
import type { ThemePreference } from '../data/types'

const THEME_COLOR = { dark: '#0a0b0c', light: '#f6f6f5' }

/** Applies the theme to the document root and keeps the status bar colour in step. */
export function useTheme(preference: ThemePreference): void {
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: light)')
    const apply = () => {
      const resolved = preference === 'system' ? (media.matches ? 'light' : 'dark') : preference
      document.documentElement.dataset.theme = resolved
      document.documentElement.classList.toggle('dark', resolved === 'dark')
      document
        .querySelector('meta[name="theme-color"]')
        ?.setAttribute('content', THEME_COLOR[resolved])
    }
    apply()
    if (preference !== 'system') return
    media.addEventListener('change', apply)
    return () => media.removeEventListener('change', apply)
  }, [preference])
}
